import React from 'react';
import { Text, Button, ButtonProps } from 'pounceV2';
import { useTheme } from '@mui/material';

interface CollapsableCellProps {
  text: string;
  hideText: string;
  showText: string;
  sliceOn?: number;
  size?: ButtonProps['size'];
}

const CollapsableCellV3: React.FC<CollapsableCellProps> = ({
  text,
  sliceOn = 100,
  hideText,
  showText,
  size = 'large',
}) => {
  const {
    palette: { tokens },
  } = useTheme();
  const [showSnippet, setShowSnippet] = React.useState(true);

  if (!text) {
    return <Text>N/A</Text>;
  }

  const isTextLong = text.length > sliceOn;

  if (!isTextLong) {
    return <Text wordBreak="break-all">{text} </Text>;
  }

  const snippet = `${text.slice(0, sliceOn)} ...`;

  return (
    <>
      {showSnippet ? (
        <Text wordBreak="break-all" color={tokens.content.text.neutral[3]}>
          {snippet}
          <Button ml={1} variant="link-primary" onClick={() => setShowSnippet(false)} size={size}>
            {showText}
          </Button>
        </Text>
      ) : (
        <Text wordBreak="break-all" color={tokens.content.text.neutral[3]}>
          {text}
          <Button ml={1} variant="link-primary" onClick={() => setShowSnippet(true)} size={size}>
            {hideText}
          </Button>
        </Text>
      )}
    </>
  );
};

export default React.memo(CollapsableCellV3);
